import React, { Component } from 'react';
import TabButton from './TabButton/TabButton';
import TabContent from './TabContent/TabContent';


export default class Tabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: 0,
        };

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(index) {
        this.setState({
            activeTab: index,
        });
    }

    render() {
        return (
            <div className="tabs-component">
                <div className="tabs-component__content">
                    {this.props.items.map((item, index) => {
                        return (
                            <TabContent key={index} index={index} url={item.url} title={item.title}
                                        isActive={this.state.activeTab === index}
                                        handleClick={this.handleClick} />
                        );
                    })}
                </div>
                <div className="tabs-component__button" role="tablist">
                    {this.props.items.map((item, index) => {
                        return (
                            <TabButton key={index} index={index} text={item.title}
                                       isActive={this.state.activeTab === index}
                                       handleClick={this.handleClick} />
                        );
                    })}
                </div>
            </div>
        );
    }
}